{
  "name": "ecl-inspire-frontend",
  "version": "0.0.11",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:dev": "npm version patch && ng build --configuration development",
    "build:test": "ng build --configuration testing",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "upload:dev": "aws s3 sync ./dist/ecl-inspire-frontend/browser s3://ecl-inspire-service-dev-inspire-frontend --delete",
    "upload:test": "aws s3 sync ./dist/ecl-inspire-frontend/browser s3://ecl-inspire-service-test-inspire-frontend --delete",
    "upload:prod": "aws s3 sync ./dist/ecl-inspire-frontend/browser s3://ecl-inspire-service-prod-inspire-frontend --delete",
    "deploy:dev": "npm run build:dev && npm run upload:dev",
    "deploy:test": "npm run build:test && npm run upload:test",
    "deploy:prod": "npm run build:prod && npm run upload:prod"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.0.3",
    "@angular/cdk": "^20.0.3",
    "@angular/common": "^20.0.3",
    "@angular/compiler": "^20.0.3",
    "@angular/core": "^20.0.3",
    "@angular/forms": "^20.0.3",
    "@angular/material": "^20.0.3",
    "@angular/platform-browser": "^20.0.3",
    "@angular/platform-browser-dynamic": "^20.0.3",
    "@angular/router": "^20.0.3",
    "amazon-cognito-identity-js": "^6.3.15",
    "chart.js": "^4.5.0",
    "rxjs": "~7.8.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.0.2",
    "@angular/cli": "^20.0.2",
    "@angular/compiler-cli": "^20.0.3",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^24.0.1",
    "autoprefixer": "^10.4.21",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.5",
    "tailwindcss": "^3.4.17",
    "typescript": "~5.8.3"
  }
}
